import { LineChart, Compass, TrendingUp, Cpu } from "lucide-react";
import { Reveal, Label } from "./Motion";
import ChapterMark from "./ChapterMark";

const categories = [
  {
    icon: LineChart,
    num: "01",
    title: "Business Intelligence",
    items: [
      "Business assessments",
      "KPI development",
      "Dashboards",
      "Financial analysis",
      "Customer analysis",
      "Performance analysis",
      "Forecasting",
    ],
  },
  {
    icon: Compass,
    num: "02",
    title: "Strategy",
    items: [
      "Strategic planning",
      "Growth strategy",
      "Competitive analysis",
      "Market opportunities",
      "Pricing strategy",
      "Customer strategy",
    ],
  },
  {
    icon: TrendingUp,
    num: "03",
    title: "Business Improvement",
    items: [
      "Cost optimization",
      "Process improvement",
      "Operational efficiency",
      "Sales improvement",
      "Customer retention",
      "Margin improvement",
    ],
  },
  {
    icon: Cpu,
    num: "04",
    title: "Technology & AI",
    items: [
      "Automation",
      "AI implementation",
      "Reporting automation",
      "System optimization",
      "Technology strategy",
      "AI opportunity identification",
    ],
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-28 lg:py-40 bg-[#eae7de]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <ChapterMark n="01" title="Diagnose" className="mb-5" />
          <Label>What we do</Label>
          <h2 className="mt-6 font-head text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight text-[#1e3d3a]">
            Four Disciplines<br />
            <span className="text-black/40">One Integrated Engagement.</span>
          </h2>
          <div className="mt-6 max-w-3xl">
            <p className="text-[10px] uppercase tracking-[0.28em] text-[#a3823f] font-medium">The Elevare Philosophy</p>
            <p className="mt-3 font-head text-lg lg:text-xl leading-snug text-[#1e3d3a]">
              Understand <span className="text-[#a3823f]">→</span> Diagnose <span className="text-[#a3823f]">→</span> Prioritize <span className="text-[#a3823f]">→</span> Strategize <span className="text-[#a3823f]">→</span> <span className="whitespace-nowrap">Implement <span className="text-[#a3823f]">→</span> Measure</span>
            </p>
            <p className="mt-3 text-base lg:text-lg leading-relaxed text-black/65">
              This becomes the foundation for every engagement.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
          {categories.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div
                data-testid={`service-category-${i}`}
                className="group h-full rounded-2xl border border-black/10 bg-white/70 backdrop-blur-sm p-8 lg:p-10 hover:bg-white hover:border-black/20 transition-colors duration-500 shadow-[0_1px_0_rgba(10,10,10,0.02)] flex flex-col"
              >
                <div className="flex items-center justify-between">
                  <c.icon className="h-7 w-7 text-[#a3823f] transition-transform duration-500 group-hover:-translate-y-1" strokeWidth={1.4} />
                  <span className="font-head text-sm font-medium tracking-[0.2em] text-black/25 tabular-nums">{c.num}</span>
                </div>
                <h3 className="mt-8 font-head text-2xl font-normal text-[#1e3d3a]">{c.title}</h3>
                <ul className="mt-6 space-y-3">
                  {c.items.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-black/65">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#a3823f]" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
